import { ReactNode } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { CallInsightHeader } from './call-insight-header';

export interface ScreenLayoutProps {
  header: ReactNode;
  content: ReactNode;
  contentStyles?: Interpolation<Theme>;
  panelStyles?: Interpolation<Theme>;
  onClose: () => void;
  trackingId?: string;
}

export const ScreenLayout: React.FC<ScreenLayoutProps> = ({
  header,
  content,
  panelStyles,
  contentStyles,
  onClose,
  trackingId,
}) => (
  <div css={panelStyles} data-trackingid={trackingId}>
    <CallInsightHeader onClose={onClose}>{header}</CallInsightHeader>
    <div css={contentStyles}>{content}</div>
  </div>
);
